import { Stack, Typography } from 'styles';
import { IHistoryItem } from 'types/History';
import { useTranslation } from 'utils/translations';

type Props = {
	item: IHistoryItem;
	isNew?: boolean;
};

const AttachmentContent = ({ item, isNew }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	const attachmentText = `claim.history.attachmentUploaded${
		isNew ? '.new' : ''
	}.${item.attachmentType.toLowerCase()}`;

	return (
		<Stack gap="5px">
			<Typography variant="body">{tClientLabels(attachmentText)}</Typography>
		</Stack>
	);
};

export default AttachmentContent;
